import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Route } from '@angular/router';

@Component({
    selector: 'sidenav-menu',
    template: `
    
    <div class="side-nav-item-menu" *ngIf="route?.children?.length">
        <div class="fieldset">
            <legend>
                {{route?.data?.title}}
            </legend>

            <ng-container *ngFor="let child of route.children">
                <a class="side-nav-item" routerLink="/{{route.path}}/{{child.path}}" routerLinkActive="active" [attr.data-tour-target]="child.path">

                    <i class="fa" [ngClass]="child.data.icon"></i>
                    <span>{{child?.data?.title}}</span>
                </a>
            </ng-container>

        </div>
    </div>
    
    `,
    styles: [
        `
            .side-nav-item.active { 
                color: #4faae7!important;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SideNavMenuComponent implements OnInit {

    @Input() public route: Route;

    constructor() { }

    ngOnInit(): void { }
}
